<template>
  <div class="scenic" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"    @resize="handleResize">
    <div class="list">
      <div class="search">
        <div class="left" @click="$router.push('citys')">
          <span>当前位置</span>
          <font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>
        </div>
        <div class="right">
          <input type="text" v-model="keywork" @input="search" placeholder="按景区标题搜索"/>
          <i class="el-icon-search"></i>
        </div>
      </div>
      <div style="height:60px"></div>
      <ul>
        <li v-for="(item,i) in (keywork === '' ? scenic : searchArr)" @click="toPush(item.id,'tkdetail')">
          <div class="title">
            <img :src="baseUrl+item.img[0]" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <font>营业时间：{{item.business}}</font>
              <div class="price">门票<i><b>¥</b>{{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>起<em style="font-style:normal;float:right;margin-right:4%;font-size:13px;color:#999;margin-top:2px">距离{{item.distance}}KM</em></div>
            </div>
          </div>
        </li>
      </ul>
      <div class="none" v-if="((keywork === '' ? scenic : searchArr).length) <= 0 && cityData.length != 0">
        <p>您所在的<font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>地区，暂无数据...</p>
        <a @click="$router.push('citys')">切换地区</a>
      </div>
    </div>
    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <footComponent :idx='1' :dx='bool' v-if="sp == 0"></footComponent>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: true,
        page:0,
        scenic:[],
        baseUrl:'',
        isIphone:false,
        keywork:'',
        sp:0,
        arr:[],
        searchArr:[],
        cityData:[],
        bool:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideToolbar');
        WeixinJSBridge.call('hideOptionMenu');
      });
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);

      if(localStorage.getItem('cCode') == null){
        //this.getQquey();
      }else{
        var cCode = JSON.parse(localStorage.getItem('cCode'));
        if(cCode.expires <= Date.parse(new Date())){
          localStorage.removeItem('cCode');
          //this.getQquey();
        }else{
          this.cityData = cCode;
          this.getscenic();
        }
      }

      var sp = this.$route.query.sp;
      this.sp = sp == 1 ? 1 : 0
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      search:function(event){
        if(this.keywork === '') return;
        var value = this.keywork;
        var res = this.arr.filter(function(item){
          return item.title.indexOf(value) > -1
        })
        this.searchArr = res;
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.getscenic();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      getscenic:function(e){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/scenicLat',
          data:{
            page:0,
            limit:80,
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.scenic = data.data;
            that.arr =data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .scenic{
    background:#ececec;
  }
  .scenic .list{
    display:block;
    overflow-y:auto;
    width:100%
  }
  .scenic .list ul{
    display:block;
    margin:0 auto;
    width:94%
  }
  .scenic .list ul li{
    display:block;
    width:100%;
    margin-bottom:15px;
    background:#fff;
    border-radius:8px;
    width:100%;
    padding:13px 0
  }
  .scenic .list ul li .title{
    position:relative;
    width:100%;
  }
  .scenic .list ul li .title:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .scenic .list ul li .title img{
    float:left;
    width:30%;
    border-radius:6px;
    margin-left:3%
  }
  .scenic .list ul li .title .conTitle{
    float:left;
    width:65%;
    margin-left:2%;
  }
  .scenic .list ul li .title .conTitle span{
    display:block;
    color:#333333;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    font-size:16px;
    font-weight: 600;
  }
  .scenic .list ul li .title .conTitle font{
    display:block;
    color:#999;
    font-size:15px;
    padding:10px 0
  }

  .scenic .list ul li .title .conTitle .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .scenic .list ul li .title .conTitle .price i{
    color: #FF6600;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .scenic .list ul li .title .conTitle .price b{
    font-size:12px;
  }

  .scenic .list .search{
    position:fixed;
    width:100%;
    left:0;
    background:#ececec;
    height:55px;
    top:0;
    z-index:99
  }


  .scenic .list .search .left{
    float:left;
    height:55px;
    width:33%;
    margin-left:3%;
    position: relative;
  }
  .scenic .list .search .left span{
    width:40px;
    float:left;
    font-size:15px;
    color:#000;
    line-height:18px;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .scenic .list .search .left span:after{
    position:absolute;
    content:'';
    width:3px;
    height:3px;
    background:#000;
    border-radius:10px;
    right:0
  }
  .scenic .list .search .left font{
    width:calc(100% - 47px);
    float:left;
    font-size:15px;
    line-height:18px;
    margin-left:7px;
    color:#666;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .scenic .list .search .right{
    float:right;
    width:57%;
    height:55px;
    margin-right:3%;
    position: relative;
  }
  .scenic .list .search input{
    height:40px;
    width:calc(100% - 40px);
    outline:none;
    border:none;
    border-radius:40px;
    margin-top:7.5px;
    padding:0 10px 0 30px;
    font-size:15px
  }
  .scenic .list .search .right i{
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    left:10px;
    color:#555;
    font-size:16px
  }
  .sihanFoot .footer{
    padding-bottom:32px
  }

  .scenic .none{
    width:80%;
    margin:0 auto;
    padding-top:30%
  }
  .scenic .none p{
    color:#333;
    font-size:15px;
    width:100%;
    text-align:center;
    margin-bottom:30px
  }
  .scenic .none p font{
    color:#e45442;
    font-weight:bold;
    padding:0 2px
  }
  .scenic .none a{
    display:block;
    background: #0059D6;
    height: 45px;
    border-radius: 8px;
    width:140px;
    text-align:center;
    line-height: 45px;
    color:#fff;
    margin:0 auto;
  }
</style>